import {BehaviorSubject, Observable} from "rxjs";
import {Injectable} from "@angular/core";


@Injectable()
export class WorkbenchKeyValStore {

    store: {[key: string]: BehaviorSubject<any>} = {};

    constructor() {
    }

    setValue(key: string, value: any) {
        if (!this.store[key]) {
            this.store[key] = new BehaviorSubject(value);
        } else if (this.store[key].getValue() !== value) {
            this.store[key].next(value);
        }
    }

    patchValue(key: string, value: any) {
        if (!this.store[key]) {
            this.store[key] = new BehaviorSubject(value);
        } else {
            const currentValue = this.store[key].getValue();
            if (Array.isArray(currentValue) && Array.isArray(value)) {
                this.store[key].next([...currentValue, ...value]);
            } else if (typeof currentValue === 'object' && typeof value === 'object') {
                this.store[key].next({...currentValue, ...value});
            } else {
                this.store[key].next(value);
            }
        }
    }

    subscribeToValue(key: string): Observable<any> {
        if (!this.store[key]) {
            this.setValue(key, undefined);
        }
        return this.store[key].asObservable();
    }

    /**
     * Returns the current value of the store or null if the key is not set.
     */
    getValue(key: string): any | null {
        if (!this.store[key]) {
            return null;
        }
        return this.store[key].getValue();
    }
}
